import { render, staticRenderFns } from "./TPreloader.vue?vue&type=template&id=3a495c96&scoped=true&"
import script from "./TPreloader.vue?vue&type=script&lang=js&"
export * from "./TPreloader.vue?vue&type=script&lang=js&"
import style0 from "./TPreloader.vue?vue&type=style&index=0&id=3a495c96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a495c96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VLayout,VOverlay,VProgressCircular})
